import { Sparkles } from "lucide-react";

// Transparensnotis enligt EU:s AI-förordning (art. 50) – visas där AI genererar innehåll.
export const AiDisclosure = ({ className = "", text }) => (
  <div
    data-testid="ai-disclosure"
    className={`flex items-start gap-2.5 rounded-xl border border-primary/20 bg-primary/[0.05] px-3.5 py-2.5 text-xs text-muted-foreground ${className}`}
  >
    <Sparkles className="h-4 w-4 text-primary shrink-0 mt-0.5" />
    <span>
      {text || (
        <>
          <strong className="text-foreground">AI-genererat innehåll.</strong> Skapat med AI utifrån dina egna uppgifter – granska och redigera alltid själv innan du använder det. AI:n fattar inga beslut åt dig och hittar aldrig på fakta.
        </>
      )}
    </span>
  </div>
);
